module.exports = __webpack_public_path__ + "img/button_first.a948c2d8.png";